import { useState, useEffect } from "react";
import { CalculatorIndexComponent } from "../components/calculator/CalculatorIndexComponent";
import { FetchProviders } from "../api/FetchProviders";
import type { ProvidersData } from "../helpers/interfaces/ProvidersInterfaces";

export const CalculatorPage = () => {
  const [providers, setProviders] = useState<ProvidersData[]>([]);
  const [providersLoading, setProvidersLoading] = useState(false);

  useEffect(() => {
    const fetchAllProviders = async () => {
      setProvidersLoading(true);
      try {
        // Fetch with a high limit to get all providers in one call
        const result = await FetchProviders({ page: 1, limit: 999 });
        if (result?.data?.data) {
          setProviders(result.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch providers for calculator:", err);
      } finally {
        setProvidersLoading(false);
      }
    };

    fetchAllProviders();
  }, []);

  return (
    <CalculatorIndexComponent
      providers={providers}
      providersLoading={providersLoading}
    />
  );
};
